<template>
<van-field name="imageUploader" :label="label" :required="required">
  <template #input>
    <van-uploader 
      v-model="fileList"
      multiple
      :max-count="maxCount"
      :capture="capture ? 'capture' : ''"
      :beforeRead="beforeRead"
      :afterRead="afterRead"
      :previewSize="previewSize"
      :disabled="disabled"
      :deletable="deletable"
      @delete="deleteImg"
    />
  </template>
</van-field>
</template>

<script>
/**
 * @author weihuahui
 * @description 图片上传组件
 * @example 示例

   <ImageUpload :label="label" v-model="imageUrlList|imageUrl"></ImageUpload>
 
 */
import { Toast } from 'vant';
export default {
  name: 'ImageUpload',
  model: {
    event: 'input'
  },
  props: {
    value: {
      type: [Array, String],
    },
    // 表单控件名
    label: {
      type: String,
      default: '设备图片'
    },
    // 预览图大小
    previewSize: {
      type: String,
      default: '50px'
    },
    //上传文件类型
    fileType: {
      type: Array,
      default: () => {
        return ['jpg', 'png', 'jpeg'];
      }
    },
    //文件大小 (单位 MB)
    fileSize: {
      type: Number,
      default: 10
    },
    // 是否必填
    required: {
      type: Boolean,
      default: false
    },
    // 是否直接拍照
    capture: {
      type: Boolean,
      default: false
    },
    maxCount: {
      type: Number,
      default: 5,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: true
    },    
  },
  
  data() {
    return {
      fileList: [], // 展示列表
    }
  },
  
  watch: {
    value(val) {
      this.parseImageList(val)
    }, 
  },

  created() {
    this.parseImageList(this.value)
  },

  methods: {
    parseImageList(val) {
      var list
      if(typeof val === 'string') {
        list = val.split(',')
      } else if(Array.isArray(val)) {
        list = val
      } else if(!val) {
        list = []
      }
      this.fileList = list.map(item => {
        if(typeof item === 'string') {
          return {url: item}
        }
        if(item.url) {
          return {url: item.url}
        }
      })
    },

    // 删除图片
    deleteImg (file, imgItem) { 
      this.value.splice(imgItem.index, 1)
      this.$emit('input', this.value)
    },

    // 上传前文件校验
    beforeRead(file) {
      let uploadType = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
      let uploadSize = file.size / 1024 / 1024 < this.fileSize
      //验证文件类型
      let isExist = this.fileType.indexOf(uploadType) === -1 ? false : true

      if (!isExist) {
        let newType = this.fileType.join('、')
        Toast({
          message: `上传文件只能是` + newType + `格式!`,
          type: 'fail'
        })
        return false
      }
      //验证文件大小
      if (!uploadSize) {
        Toast({
          message: `上传文件大小不能超过 ` + this.fileSize + `MB!`,
          type: 'warning'
        })
        return false
      }
      // 通过验证   
      return true
    },

    // 上传处理
    afterRead(file) {
      const _this = this
      let formData = new FormData()
      formData.append('file', file.file)

      this.$http.uploadFile('/file/upload', formData).then(res => {
        if (res.code === 200) {
          let imgList = []
          if(Array.isArray(_this.value)) {
            imgList = [..._this.value]
          } else if(typeof _this.value === 'string') {
            imgList = _this.value.split(',')
          }
          imgList.push(res.data.url)
          _this.$emit('input', imgList)
        } else {
          Toast('上传失败，请重试1')
        }
      }).catch(() => {
        Toast('上传失败，请重试2')
      })
    }
  },
}
</script>